import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.link.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0e672eb2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "userLogin"
};
var _hoisted_2 = {
  class: "user"
};
var _hoisted_3 = {
  class: "user-name linelittle"
};
var _hoisted_4 = {
  class: "userInfo"
};
var _hoisted_5 = {
  class: "user-status"
};
var _hoisted_6 = {
  class: "status-count"
};
var _hoisted_7 = {
  class: "status-title"
};
var _hoisted_8 = {
  class: "user-opearte"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-hkquit"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1
  /* HOISTED */
  );
});

var _hoisted_11 = [_hoisted_9, _hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "user-name linelittle"
  }, "点击登录", -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_avatar = _resolveComponent("el-avatar");

  var _component_caretRight = _resolveComponent("caretRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_link = _resolveComponent("el-link");

  var _component_el_popover = _resolveComponent("el-popover");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 用户登录了 "), Object.keys(_ctx.userInfo).length ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 0,
    width: 318,
    trigger: "click",
    placement: "right-start"
  }, {
    reference: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 头像 "), _createVNode(_component_el_avatar, {
        size: 40,
        src: _ctx.userInfo.avatarUrl
      }, null, 8
      /* PROPS */
      , ["src"]), _createCommentVNode(" 用户名 "), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userInfo.nickname), 1
      /* TEXT */
      ), _createCommentVNode(" 右箭头图标 "), _createVNode(_component_el_icon, {
        size: 15
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_caretRight)];
        }),
        _: 1
        /* STABLE */

      })])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_4, [_createCommentVNode(" 动态、关注、粉丝 "), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseInfo, function (status, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "status-item",
          key: index
        }, [_createElementVNode("div", _hoisted_6, _toDisplayString(status.count), 1
        /* TEXT */
        ), _createElementVNode("div", _hoisted_7, _toDisplayString(status.title), 1
        /* TEXT */
        )]);
      }), 128
      /* KEYED_FRAGMENT */
      ))]), _createCommentVNode(" 会员、等级、商城 "), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opearteInfo, function (opea, index) {
        return _openBlock(), _createBlock(_component_el_link, {
          underline: false,
          target: "_blank",
          href: opea.link,
          class: "opearte-item",
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("i", {
              class: _normalizeClass(['iconfont', opea.icon])
            }, null, 2
            /* CLASS */
            ), _createElementVNode("span", null, _toDisplayString(opea.title), 1
            /* TEXT */
            )];
          }),
          _: 2
          /* DYNAMIC */

        }, 1032
        /* PROPS, DYNAMIC_SLOTS */
        , ["href"]);
      }), 128
      /* KEYED_FRAGMENT */
      ))]), _createElementVNode("div", {
        class: "user-logout",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.logoutClick && _ctx.logoutClick.apply(_ctx, arguments);
        })
      }, _hoisted_11)])];
    }),
    _: 1
    /* STABLE */

  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 用户没登录 "), _createElementVNode("div", {
    class: "user",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.loginClick && _ctx.loginClick.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_el_avatar, {
    size: 40,
    src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
  }), _createCommentVNode(" 用户名 "), _hoisted_12, _createCommentVNode(" 右箭头图标 "), _createVNode(_component_el_icon, {
    size: 15
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_caretRight)];
    }),
    _: 1
    /* STABLE */

  })])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  ))]);
}